import {
  AspectRatio,
  AspectRatioProps,
  Box,
  BoxProps,
  Center,
  CenterProps,
  Circle,
  Container,
  ContainerProps,
  Divider,
  Flex,
  FlexProps,
  Grid,
  GridProps,
  GridItem,
  GridItemProps,
  SimpleGrid,
  SimpleGridProps,
  Spacer,
  SpacerProps,
  Square,
  SquareProps,
  Stack,
  StackProps,
  StackDivider,
  StackDividerProps,
  HStack,
  VStack,
  Wrap,
  WrapProps,
  WrapItem,
  WrapItemProps
} from '@chakra-ui/react';

import DisplayNames from './enums';

AspectRatio.displayName = DisplayNames.AspectRatio;
Box.displayName = DisplayNames.Box;
Center.displayName = DisplayNames.Center;
Circle.displayName = DisplayNames.Circle;
Container.displayName = DisplayNames.Container;
Divider.displayName = DisplayNames.Divider;
Flex.displayName = DisplayNames.Flex;
Grid.displayName = DisplayNames.Grid;
GridItem.displayName = DisplayNames.GridItem;
SimpleGrid.displayName = DisplayNames.SimpleGrid;
Spacer.displayName = DisplayNames.Spacer;
Square.displayName = DisplayNames.Square;
Stack.displayName = DisplayNames.Stack;
HStack.displayName = DisplayNames.HStack;
VStack.displayName = DisplayNames.VStack;
Wrap.displayName = DisplayNames.Wrap;
WrapItem.displayName = DisplayNames.WrapItem;

export const containerMaxWOptions = [
  'container.xl',
  'container.sm',
  'container.md',
  'container.lg',
  'xl',
  'lg',
  'md',
  'sm'
];

export {
  AspectRatio,
  AspectRatioProps,
  Box,
  BoxProps,
  Center,
  CenterProps,
  Circle,
  Container,
  ContainerProps,
  Divider,
  Flex,
  FlexProps,
  Grid,
  GridProps,
  GridItem,
  GridItemProps,
  SimpleGrid,
  SimpleGridProps,
  Spacer,
  SpacerProps,
  Square,
  SquareProps,
  Stack,
  StackProps,
  StackDivider,
  StackDividerProps,
  HStack,
  VStack,
  Wrap,
  WrapProps,
  WrapItem,
  WrapItemProps
};
